import React, {useState} from 'react'
import RowJson from "../../../api/json/RowJson"
import {Box, Paper, Stack, Typography} from "@mui/material"
import {ProjectJson} from "../../../api/json/ProjectJson";
import styles from "./RowCard.module.scss";
import {TimeUtil} from "../../../library/TimeUtil";
import {RowDataset} from "../../../api/enum/RowDataset";
import {RowOrigin} from "../../../api/enum/RowOrigin"
import animations from "../../../Animations.module.scss"
import TemplateRenderer from "../../templates/TemplateRenderer"
import CreateRowModal from "../CreateRowModal"
import SpaceBetween from "../../common/SpaceBetween"
import {AnyTemplateJson} from "../../../api/json/TemplateJson"

interface RowCardProps {
    row: RowJson
    project: ProjectJson
    template?: AnyTemplateJson
    didUpdate?: (row: RowJson) => void
    didDelete?: (row: RowJson) => void
}

function RowCard({row, project, template, didUpdate, didDelete}: RowCardProps) {
    const [editModalOpen, setEditModalOpen] = useState<boolean>(false)

    return (
        <>
            <Box
                className={`${styles.cardContainer} ${row.dataset === RowDataset.TRAINING ? styles.training : styles.validation} ${animations.defaultIn}`}
                onClick={() => setEditModalOpen(true)}
                sx={{position: "relative", p: 1.8}}>

                <Stack component={Paper} spacing={1}>
                    <Box className={styles.renderedExample}>
                        {template ?
                            <TemplateRenderer dataSource={row.cells}
                                              templateParts={template}
                                              staticSystemPromptTreatment="hide"/>
                            : <>
                                {row.cells.map(cell =>
                                    <Typography paragraph sx={{whiteSpace: "pre-wrap"}}>
                                        {cell.value}
                                    </Typography>,
                                )}
                            </>
                        }
                    </Box>

                    <SpaceBetween>
                        <Typography variant="caption">{TimeUtil.ago(row.updated)}</Typography><br/>
                    </SpaceBetween>
                </Stack>
            </Box>

            {didUpdate && didDelete &&
                <CreateRowModal
                    open={editModalOpen}
                    onClose={() => {
                        setEditModalOpen(false)
                    }}
                    project={project}
                    origin={RowOrigin.MANUAL}
                    row={row}
                    didUpdate={row => {
                        setEditModalOpen(false)
                        didUpdate(row)
                    }}
                    didDelete={() => {
                        setEditModalOpen(false)
                        didDelete(row)
                    }}
                />
            }
        </>
    )
}

export default RowCard
